<template>
  <div>
    <el-card class="box-card">
      <div slot="header">
        <span>主题评价报告</span>
      </div>
      <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
        <el-tab-pane label="幼儿报告" name="second">
          <el-row>
            <el-col style="display: flex; align-items: center; flex-wrap: wrap">
              <el-select
                v-model="StudyNameCopy"
                class="dropdown"
                style="margin: 0.125rem"
                placeholder="请选择学届"
                @change="onClickDropdownAcademicSelectCopy"
              >
                <el-option
                  v-for="item in optionsStudyCopy"
                  :key="item.Name"
                  :value="item.Id"
                  :label="item.Name"
                >
                </el-option>
              </el-select>
              <el-select
                style="margin: 0.125rem"
                v-model="ClassIdCopy"
                class="dropdown"
                placeholder="请选择班级"
              >
                <el-option
                  v-for="item in optionsClassCopy"
                  :key="item.ClassId"
                  :value="item.ClassId"
                  :label="item.GradeName + item.ClassName"
                >
                </el-option>
              </el-select>
              <el-select
                style="margin: 0.125rem"
                class="dropdown"
                v-model="ThemeValueCopy"
                filterable
                placeholder="请输入评测主题"
                @visible-change="dropdownAcademicThemeCopy"
                @change="onChangeTheme"
              >
                <el-option
                  v-for="item in ThemeListCopy"
                  :key="item.Id"
                  :label="item.Name"
                  :value="item.Id"
                >
                </el-option>
              </el-select>

              <el-input
                style="width: 2.5rem; margin: 0.125rem"
                v-model="ChildrenName"
                placeholder="请输入幼儿姓名"
                class="dropdown"
              ></el-input>
              <el-select
                v-model="Status1"
                placeholder="请选择老师评"
                class="dropdown"
                style="margin: 0.125rem"
                @change="onChangeTeacher"
              >
                <el-option label="已评" value="1"></el-option>
                <el-option label="未评" value="0"></el-option>
              </el-select>
              <el-select
                :disabled="disableStatus"
                v-model="Status2"
                placeholder="请选择家长评"
                class="dropdown"
                style="margin: 0.125rem"
                @change="onChangeCustomer"
              >
                <el-option label="已评" value="2"></el-option>
                <el-option label="未评" value="3"></el-option>
              </el-select>
              <el-select
                :disabled="disableStatus"
                v-model="Status3"
                placeholder="请选择幼儿评"
                class="dropdown"
                style="margin: 0.125rem"
                @change="onChangeChildren"
              >
                <el-option label="已评" value="4"></el-option>
                <el-option label="未评" value="5"></el-option>
              </el-select>
              <el-button
                style="margin: 0.125rem"
                type="primary"
                @click="onClickInput"
                >查询</el-button
              >
              <el-button
                style="margin: 0.125rem"
                type="primary"
                @click="onClickClear"
                >清空选项</el-button
              >
              <el-button
                style="margin: 0.125rem"
                type="primary"
                v-if="
                  userInfo.UserIdentity.indexOf('2') != -1 &&
                  ThemeValueCopy != ''
                "
                @click="onClickEvaluate"
                >批量评价</el-button
              >
            </el-col>
            <el-col style="margin-top: 0.25rem">
              <el-table
                :data="tableDataCopy"
                border
                style="width: 100%"
                :header-cell-style="{
                  background: '#F2F5FF',
                  color: '#333',
                }"
                ref="multipleTable"
                :cell-style="{ textAlign: 'center' }"
                @selection-change="handleSelectionChange"
                empty-text="暂无数据"
              >
                <el-table-column
                  type="selection"
                  width="55"
                  :selectable="checkSelectable"
                >
                </el-table-column>

                <el-table-column label="序号" width="60" align="center">
                  <template slot-scope="scope">
                    {{ scope.$index + (PageIndexCopy - 1) * PageSizeCopy + 1 }}
                  </template>
                </el-table-column>
                <el-table-column prop="Title" label="评测主题" align="center">
                </el-table-column>
                <el-table-column
                  prop="StudyYearName"
                  label="学届"
                  align="center"
                >
                </el-table-column>
                <el-table-column prop="ClassName" label="班级" align="center">
                </el-table-column>
                <el-table-column
                  prop="ChildrenName"
                  label="幼儿姓名"
                  align="center"
                >
                </el-table-column>
                <el-table-column label="性别" align="center">
                  <template slot-scope="scope">
                    {{ scope.row.Sex == 0 ? "男" : "女" }}
                  </template>
                </el-table-column>
                <el-table-column label="老师评" align="center">
                  <template slot-scope="scope">
                    {{ scope.row.Status >= 1 ? "已评" : "未评" }}
                  </template>
                </el-table-column>
                <el-table-column label="家长评" align="center">
                  <template slot-scope="scope">
                    {{ scope.row.Status >= 2 ? "已评" : "未评" }}
                  </template>
                </el-table-column>
                <el-table-column label="幼儿评" align="center">
                  <template slot-scope="scope">
                    {{ scope.row.Status >= 3 ? "已评" : "未评" }}
                  </template>
                </el-table-column>
                <el-table-column label="操作" align="center">
                  <template slot-scope="scope">
                    <el-button
                      type="text"
                      :disabled="true"
                      v-if="scope.row.Status == -1"
                      >已关闭</el-button
                    >
                    <!-- 查看报告 -->
                    <el-button
                      type="text"
                      @click="lookChildReport(scope.row)"
                      v-if="scope.row.Status != -1 && scope.row.Status != 0"
                      >查看报告</el-button
                    >
                    <template v-if="userInfo.UserIdentity.indexOf('2') != -1">
                      <el-button
                        @click="recordFn(scope.row)"
                        type="text"
                        v-if="scope.row.Status != -1 && userInfo.ParentId != 12"
                        >{{ scope.row.Status == 0 ? "去评价" : "修改" }}
                      </el-button>
                    </template>
                    <template v-if="userInfo.UserIdentity.indexOf('2') == -1">
                      <el-button
                        type="text"
                        v-if="scope.row.Status != -1 && userInfo.ParentId != 12"
                        >未评价
                      </el-button>
                    </template>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination
                background
                @size-change="handleSizeChange"
                layout="sizes, prev, pager, next"
                @current-change="handleCurrentChangeCopy"
                :page-sizes="[20, 30, 40, 50]"
                :current-page="PageIndexCopy"
                :page-size="PageSizeCopy"
                :total="totalCopy"
                style="text-align: center;padding:0.25rem; 0 0 0"
              >
              </el-pagination>
            </el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="班级报告" name="first">
          <el-row>
            <el-col style="display: flex; align-items: center; flex-wrap: wrap">
              <el-select
                v-model="StudyName"
                class="dropdown"
                style="margin-left: 0"
                placeholder="请选择学届"
                @change="onClickDropdownAcademicSelect"
              >
                <el-option
                  v-for="item in optionsStudy"
                  :key="item.Name"
                  :label="item.Name"
                  :value="item.Id"
                >
                </el-option>
              </el-select>
              <el-select
                v-model="ClassId"
                class="dropdown"
                placeholder="请选择班级"
              >
                <el-option
                  v-for="item in optionsClass"
                  :key="item.ClassId"
                  :value="item.ClassId"
                  :label="item.GradeName + item.ClassName"
                >
                </el-option>
              </el-select>
              <el-select
                class="dropdown"
                v-model="ThemeValue"
                filterable
                placeholder="请输入评测主题"
                @change="GetEval_ThemeClassByPage"
              >
                <el-option
                  v-for="item in ThemeList"
                  :key="item.Id"
                  :label="item.Name"
                  :value="item.Id"
                >
                </el-option>
              </el-select>
              <el-button
                style="margin-left: 0.25rem"
                type="primary"
                @click="onClickSearch"
                >查询</el-button
              >
              <el-button
                style="margin-left: 0.25rem"
                type="primary"
                @click="clearSearch"
                >清空选项</el-button
              >
            </el-col>
            <el-col style="margin-top: 0.25rem">
              <el-table
                :data="tableData"
                border
                style="width: 100%"
                :header-cell-style="{
                  background: '#F2F5FF',
                  color: '#333',
                }"
                :cell-style="{ textAlign: 'center' }"
                empty-text="暂无数据"
              >
                <el-table-column label="序号" width="60" align="center">
                  <template slot-scope="scope">
                    {{ scope.$index + (PageIndex - 1) * PageSize + 1 }}
                  </template>
                </el-table-column>
                <el-table-column prop="Title" label="评测主题" align="center">
                </el-table-column>
                <el-table-column
                  prop="StudyYearName"
                  label="学届"
                  align="center"
                >
                </el-table-column>
                <el-table-column prop="GradeName" label="年级" align="center">
                </el-table-column>
                <el-table-column prop="ClassName" label="班级" align="center">
                </el-table-column>
                <el-table-column prop="TestNum" label="评测人数" align="center">
                </el-table-column>
                <el-table-column label="操作" align="center">
                  <template slot-scope="scope">
                    <el-button
                      type="text"
                      :disabled="scope.row.TestCount == 0"
                      @click="onClickChildResult(scope.row)"
                      >查看报告</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination
                layout="prev, pager, next"
                @current-change="handleCurrentChange"
                :page-size="PageSize"
                :current-page="PageIndex"
                :total="total"
                style="text-align: center; padding: 0.25rem"
              >
              </el-pagination>
            </el-col>
          </el-row>
        </el-tab-pane>
      </el-tabs>
    </el-card>
  </div>
</template>
<script>
import {
  getAcademicSelect,
  GetClassList,
  GetEval_ThemeClassByPage,
  GetThemeSelect,
  GetEval_ThemeStudentByPage,
} from "../../api/api";

export default {
  data() {
    return {
      tableData: [],
      tableDataCopy: [],
      activeName: "second",
      StudyNameCopy: "",
      StudyName: "",
      ClassIdCopy: "",
      ClassId: "",
      optionsStudyCopy: [],
      optionsStudy: [],
      optionsClassCopy: [],
      optionsClass: [],
      PageIndexCopy: 1,
      PageIndex: 1,
      PageSizeCopy: 20,
      PageSize: 10,
      ThemeValueCopy: "",
      ThemeValue: "",
      ThemeListCopy: [],
      ThemeList: [],
      totalCopy: 0,
      total: 0,
      ChildrenName: "",
      Status1: "",
      Status2: "",
      Status3: "",
      disableStatus: false,
      userInfo: {},
      mapId: [],
    };
  },
  async created() {
    this.userInfo = JSON.parse(window.localStorage.getItem("user"));

    console.log(this.$route.query, "this.$route.query.params");
    if (this.$route.query.params) {
      var params = JSON.parse(this.$route.query.params);
      this.StudyNameCopy = params.StudyNameCopy;
      this.ClassIdCopy = params.ClassIdCopy;
      this.ThemeValueCopy = params.ThemeValueCopy;
      this.ChildrenName = params.ChildrenName;
      this.Status1 = params.Status1;
      this.Status2 = params.Status2;
      this.Status3 = params.Status3;
      this.StudyName = params.StudyName;
      this.ClassId = params.ClassId;
      this.ThemeValue = params.ThemeValue;
      this.activeName = params.activeName;
      this.PageIndex = params.PageIndex;
      this.PageIndexCopy = params.PageIndexCopy;
    }
    this.__initClass();
    this.GetClassList();
    this.GetThemeSelect();
    if (this.activeName == "second") {
      this.dropdownAcademicSelectCopy();

      this.GetEval_ThemeStudentByPage();
    } else {
      this.dropdownAcademicSelect();
      this.GetEval_ThemeClassByPage();
    }
  },
  methods: {
    GetThemeSelect() {
      GetThemeSelect({ Id: 0 }).then((res) => {
        if (res.data.success) {
          this.ThemeListCopy = res.data.response;
          this.ThemeList = res.data.response;
        } else {
          this.ThemeListCopy = [];
        }
      });
    },
    GetClassList() {
      GetClassList({
        StudyYearsId: this.StudyNameCopy == "" ? 0 : this.StudyNameCopy,
        SchoolId: this.userInfo.SchoolId,
      }).then((res) => {
        if (res.status == 200) {
          this.optionsClassCopy = res.data.response.data;
        }
      });
    },
    __initClass() {
      var YearIds = this.optionsStudy
        .filter((x) => x.Id == this.StudyName)
        .map((x) => {
          return x.Id;
        });
      GetClassList({
        StudyYearsId: YearIds.shift(),
        SchoolId: this.userInfo.SchoolId,
      }).then((res) => {
        if (res.data.success) {
          this.optionsClass = res.data.response.data;
          // //console.log(this.optionsClass,'this.optionsClass')
        }
      });
    },
    judgeSelect(row, index) {
      console.log(row, "row");
      return row.Status == 3; // 返回true该行可选，返回false则不可选
    },
    handleSizeChange(val) {
      this.PageSizeCopy = val;
      this.GetEval_ThemeStudentByPage();
    },
    handleSelectionChange(val) {
      this.mapId = val.map((item) => {
        return {
          ThemeMapId: item.ThemeMapId,
          Title: item.Title,
          ThemeId: item.ThemeId,
          CustomerId: item.StudentId,
        };
      });
    },
    checkSelectable(row, index) {
      //console.log(row);
      let flag = false;
      if (row.Status == 0) {
        flag = true;
      }
      return flag;
    },

    // 批量评价
    onClickEvaluate() {
      var params = {
        StudyNameCopy: this.StudyNameCopy,
        ClassIdCopy: this.ClassIdCopy,
        ThemeValueCopy: this.ThemeValueCopy,
        ChildrenName: this.ChildrenName,
        Status1: this.Status1,
        Status2: this.Status2,
        Status3: this.Status3,
        activeName: this.activeName,
        StudyName: this.StudyName,
        ClassId: this.ClassId,
        ThemeValue: this.ThemeValue,
        PageIndexCopy: this.PageIndexCopy,
        PageIndex: this.PageIndex,
      };
      if (this.mapId.length != 0) {
        this.mapId.forEach((c) => {
          if (c.Title == c.Title) {
            this.$router.push({
              path: "/SubjectResultSetQuestion",
              query: {
                themeMapIds: JSON.stringify(this.mapId),
                CustomerId: this.mapId[0].StudentId,
                ThemeId: this.mapId[0].ThemeId,
                typeStatus: true,
                params: JSON.stringify(params),
              },
            });
          } else {
            this.$message({
              type: "error",
              message: "请选择同一主题进行批量评价",
            });
          }
        });
      } else {
        this.$message({
          type: "error",
          message: "请选择需要评价的数据",
        });
      }
    },
    onClickClear() {
      this.StudyNameCopy = "";
      this.ClassIdCopy = "";
      this.ThemeValueCopy = "";
      this.ChildrenName = "";
      this.Status1 = "";
      this.Status2 = "";
      this.Status3 = "";
      this.$router.replace({
        path: this.$route.path,
        query: {},
      });
      this.GetEval_ThemeStudentByPage();
    },
    clearSearch() {
      this.StudyName = "";
      this.ClassId = "";
      this.ThemeValue = "";
      this.$router.replace({
        path: this.$route.path,
        query: {},
      });
      this.GetEval_ThemeClassByPage();
    },
    onClickSearch() {
      this.$router.replace({
        path: this.$route.path,
        query: {},
      });
      this.PageIndex = 1;
      this.GetEval_ThemeClassByPage();
    },
    onClickInput() {
      this.$router.replace({
        path: this.$route.path,
        query: {},
      });
      this.PageIndexCopy = 1;
      this.GetEval_ThemeStudentByPage();
    },
    onChangeTeacher(val) {
      // if (val == 1) {
      //   this.disableStatus = false;
      // } else {
      //   this.disableStatus = true;
      // }
      this.Status2 = "";
      this.Status3 = "";
    },
    onChangeCustomer() {
      this.Status1 = "";
      this.Status3 = "";
    },
    onChangeChildren() {
      this.Status2 = "";
      this.Status1 = "";
    },
    GetEval_ThemeStudentByPage() {
      var result = [...this.Status1, ...this.Status2, ...this.Status3];
      var sum = -1;
      for (var i = 0; i < result.length; i++) {
        if (result[i] > sum) {
          sum = result[i];
        }
      }
      //console.log(sum, "a");
      const params = {
        ThemeId: this.ThemeValueCopy == "" ? 0 : this.ThemeValueCopy,
        StudyYearId: this.StudyNameCopy == "" ? 0 : this.StudyNameCopy,
        ClassId: this.ClassIdCopy == "" ? 0 : this.ClassIdCopy,
        PageIndex: this.PageIndexCopy,
        PageSize: this.PageSizeCopy,
        ChildrenName: this.ChildrenName,
        Status: sum, //教师评后=1 家长评后=2 幼儿评后=3 三种状态 0是什么也没评
      };
      GetEval_ThemeStudentByPage(params).then((res) => {
        if (res.data.success) {
          this.tableDataCopy = res.data.response.data;
          this.totalCopy = res.data.response.dataCount;
        } else {
          this.tableDataCopy = [];
          this.totalCopy = 0;
        }
      });
    },
    handleCurrentChange(val) {
      this.PageIndex = val;
      this.GetEval_ThemeClassByPage();
    },
    handleCurrentChangeCopy(val) {
      this.PageIndexCopy = val;
      this.GetEval_ThemeStudentByPage();
    },
    GetEval_ThemeClassByPage() {
      const params = {
        ThemeId: this.ThemeValue == "" ? 0 : this.ThemeValue,
        StudyYearId: this.StudyName == "" ? 0 : this.StudyName,
        ClassId: this.ClassId == "" ? 0 : this.ClassId,
        PageIndex: this.PageIndex,
        PageSize: this.PageSize,
      };
      GetEval_ThemeClassByPage(params).then((res) => {
        if (res.data.success) {
          this.tableData = res.data.response.data;
          this.total = res.data.response.dataCount;
        } else {
          this.tableData = [];
          this.total = 0;
        }
      });
    },
    // 查看幼儿报告
    lookChildReport(item) {
      const href = this.$router.resolve({
        path: "/SubjectResultChildResult",
        query: {
          CustomerId: item.StudentId,
          ThemeId: item.ThemeId,
          ThemeMapId: item.ThemeMapId,
          ClassName: item.ClassName,
          StudyYearName: item.StudyYearName,
          GradeName: item.GradeName,
          ChildrenName: item.ChildrenName,
          Title: item.Title,
          ClassId: item.ClassId,
          StudyYearId: item.StudyYearId,
          GradeId: item.GradeId,
          SchoolName: this.userInfo.SchoolName,
        },
      });
      window.open(href.href, "_blank");
    },
    // 去记录
    recordFn(item) {
      var params = {
        StudyNameCopy: this.StudyNameCopy,
        ClassIdCopy: this.ClassIdCopy,
        ThemeValueCopy: this.ThemeValueCopy,
        ChildrenName: this.ChildrenName,
        Status1: this.Status1,
        Status2: this.Status2,
        Status3: this.Status3,
        activeName: this.activeName,
        StudyName: this.StudyName,
        ClassId: this.ClassId,
        ThemeValue: this.ThemeValue,
        PageIndexCopy: this.PageIndexCopy,
        PageIndex: this.PageIndex,
      };
      this.$router.push({
        path: "/SubjectResultSetQuestion",
        query: {
          CustomerId: item.StudentId,
          ThemeId: item.ThemeId,
          ThemeMapId: item.ThemeMapId,
          ClassName: item.ClassName,
          StudyYearName: item.StudyYearName,
          GradeName: item.GradeName,
          ChildrenName: item.ChildrenName,
          params: JSON.stringify(params),
        },
      });
    },
    //   幼儿报告
    onClickChildResult(item) {
      if (this.activeName == "second") {
        if (item.Status == 3) {
          const href = this.$router.resolve({
            path: "/SubjectResultChildResult",
            query: {
              CustomerId: item.StudentId,
              ThemeId: item.ThemeId,
              ThemeMapId: item.ThemeMapId,
              ClassName: item.ClassName,
              StudyYearName: item.StudyYearName,
              GradeName: item.GradeName,
              ChildrenName: item.ChildrenName,
              Title: item.Title,
              ClassId: item.ClassId,
              StudyYearId: item.StudyYearId,
              GradeId: item.GradeId,
              SchoolName: this.userInfo.SchoolName,
            },
          });
          window.open(href.href, "_blank");
        } else if (item.Status != -1) {
          this.$router.push({
            path: "/SubjectResultSetQuestion",
            query: {
              CustomerId: item.StudentId,
              ThemeId: item.ThemeId,
              ThemeMapId: item.ThemeMapId,
              ClassName: item.ClassName,
              StudyYearName: item.StudyYearName,
              GradeName: item.GradeName,
              ChildrenName: item.ChildrenName,
            },
          });
        }
      } else {
        const href = this.$router.resolve({
          path: "/SubjectResultClassResult",
          query: {
            ClassName: item.ClassName,
            StudyYearName: item.StudyYearName,
            GradeName: item.GradeName,
            ThemeId: item.ThemeId,
            ChildrenName: item.ChildrenName,
            Title: item.Title,
            ClassId: item.ClassId,
            StudyYearId: item.StudyYearId,
            GradeId: item.GradeId,
            SchoolName: this.userInfo.SchoolName,
          },
        });
        window.open(href.href, "_blank");
      }
    },
    handleClick(e) {
      this.activeName = e.name;
      if (e.name == "second") {
        this.dropdownAcademicSelectCopy();

        this.GetEval_ThemeStudentByPage();
      } else {
        this.dropdownAcademicSelect();
        this.GetEval_ThemeClassByPage();
      }
      //console.log(e, "aaaaaa");
    },
    //下拉学届菜单
    dropdownAcademicSelect() {
      let UserIdentityArr = this.userInfo.UserIdentity.split(";");
      let isKindergarten = UserIdentityArr.find((item) => {
        return item == 1;
      });
      getAcademicSelect({
        Uid: this.userInfo.uID,
        SchoolId: this.userInfo.SchoolId,
        Type: isKindergarten ? 3 : 2, //EvaluationType==2 1学生、2教师、3校长、4家长
      }).then((res) => {
        if (res.status == 200) {
          this.optionsStudy = res.data.response;
        }
      });
    },
    onClickDropdownAcademicSelect(e) {
      var YearIds = this.optionsStudy
        .filter((x) => x.Id == this.StudyName)
        .map((x) => {
          return x.Id;
        });
      //console.log(show, "aYearIds");

      GetClassList({
        StudyYearsId: YearIds.shift(),
        SchoolId: this.userInfo.SchoolId,
      }).then((res) => {
        if (res.data.success) {
          this.optionsClass = res.data.response.data;
          // //console.log(this.optionsClass,'this.optionsClass')
        }
      });
    },

    dropdownAcademicTheme(show) {
      if (show == true) {
        GetThemeSelect({ Id: 0 }).then((res) => {
          if (res.data.success) {
            this.ThemeList = res.data.response;
          } else {
            this.ThemeList = [];
          }
        });
      }
    },
    //下拉学届菜单
    dropdownAcademicSelectCopy() {
      let UserIdentityArr = this.userInfo.UserIdentity.split(";");
      let isKindergarten = UserIdentityArr.find((item) => {
        return item == 1;
      });
      getAcademicSelect({
        Uid: this.userInfo.uID,
        SchoolId: this.userInfo.SchoolId,
        Type: isKindergarten ? 3 : 2, //EvaluationType==2 1学生、2教师、3校长、4家长
      }).then((res) => {
        if (res.status == 200) {
          // //console.log(res.data.response);
          this.optionsStudyCopy = res.data.response;
        }
      });
    },
    onClickDropdownAcademicSelectCopy(e) {
      var YearIds = this.optionsStudyCopy
        .filter((x) => x.Id == this.StudyNameCopy)
        .map((x) => {
          return x.Id;
        });
      GetClassList({
        StudyYearsId: YearIds.shift(),
        SchoolId: this.userInfo.SchoolId,
      }).then((res) => {
        if (res.status == 200) {
          this.optionsClassCopy = res.data.response.data;
        }
      });
    },
    onChangeTheme(e) {
      console.log(e);
      this.ThemeValueCopy = e;
      this.GetEval_ThemeStudentByPage();
    },
    dropdownAcademicThemeCopy(show) {
      if (show == true) {
        GetThemeSelect({ Id: 0 }).then((res) => {
          if (res.data.success) {
            this.ThemeListCopy = res.data.response;
          } else {
            this.ThemeListCopy = [];
          }
        });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.dropdown {
  // width: calc(100% / 4 - 20px);
  margin-left: 20px;
  /* margin-top: 20px; */
}
.unselectable {
  cursor: not-allowed; // 当鼠标指针移动到这种行的选框上时，鼠标指针将会变成一个圆圈，表示这种行不能被勾选。
}
.box-card {
  width: 100%;
  span {
    font-size: 22px;
    font-weight: 600;
  }
}
.tui-edit {
  display: flex;
  align-items: center;
  margin-top: 20px;
  span {
    font-size: 22px;
    font-weight: bold;
  }
  i {
    font-size: 25px;
  }
}
</style>